(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    let cleanup;
    const initScrollHeader = () => {
      cleanup?.();
      const header = document.querySelector('.riff-scroll-header');
      if (!header) return;
      const controller = new AbortController();
      const { signal } = controller;
      let previousY = Math.max(0, window.scrollY);
      let travel = 0;
      let frame = 0;
      const show = () => {
        header.classList.remove('is-scroll-hidden');
        travel = 0;
      };
      const update = () => {
        frame = 0;
        // Clamp Safari's overscroll so bouncing at either end cannot flip direction.
        const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const y = Math.max(0, Math.min(window.scrollY, maxY));
        const delta = y - previousY;
        previousY = y;
        if (y <= header.offsetHeight || header.matches(':focus-within') || header.querySelector('details[open]')) {
          show();
          return;
        }
        travel = Math.sign(delta) === Math.sign(travel) ? travel + delta : delta;
        // Ignore tiny scroll movements to prevent flicker.
        if (Math.abs(travel) >= 8) {
          header.classList.toggle('is-scroll-hidden', travel > 0);
          travel = 0;
        }
      };
      window.addEventListener('scroll', () => {
        if (!frame) frame = requestAnimationFrame(update);
      }, { passive: true, signal });
      header.addEventListener('focusin', show, { signal });
      header.addEventListener('toggle', () => {
        if (header.querySelector('details[open]')) show();
      }, { capture: true, signal });
      window.addEventListener('pageshow', () => {
        previousY = Math.max(0, window.scrollY);
        show();
      }, { signal });
      cleanup = () => {
        controller.abort();
        cancelAnimationFrame(frame);
        show();
      };
    };
    initScrollHeader();
    document.addEventListener('shopify:section:load', initScrollHeader);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.matches('.riff-scroll-header')) cleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-riff-product]').forEach((section) => {
    const variantsNode = section.querySelector('[data-variants-json]');
    const select = section.querySelector('[data-variant-select]');
    if (!variantsNode || !select) return;

    const variants = JSON.parse(variantsNode.textContent);
    const optionGroups = [...section.querySelectorAll('[data-option-position]')];
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const productPrice = section.querySelector('[data-product-price]');
    const productMedia = [...section.querySelectorAll('[data-product-media]')];
    const imageExpandButtons = [...section.querySelectorAll('[data-product-image-expand]')];
    const lightbox = section.querySelector('[data-product-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
    const lightboxCount = lightbox?.querySelector('[data-lightbox-count]');
    const lightboxMedia = lightbox?.querySelector('[data-lightbox-media]');
    const lightboxPrevious = lightbox?.querySelector('[data-lightbox-previous]');
    const lightboxNext = lightbox?.querySelector('[data-lightbox-next]');
    const sizeGuide = section.querySelector('[data-size-guide]');
    const sizeGuideTriggers = [...section.querySelectorAll('[data-size-guide-open]')];
    const sizeGuideUnitButtons = [...section.querySelectorAll('[data-size-unit]')];
    const sizeGuideMeasurements = [...section.querySelectorAll('[data-size-measurement]')];
    const recommendationsRail = section.querySelector('[data-product-recommendations-rail]');
    const colorGroup = optionGroups.find((group) => /colou?r/i.test(group.dataset.optionName || ''));
    const colorOptionIndex = colorGroup ? Number(colorGroup.dataset.optionPosition) - 1 : -1;

    const normalizeColor = (value) => value
      .toLowerCase()
      .replace(/gray/g, 'grey')
      .replace(/[^a-z0-9]/g, '');

    const escapeHtml = (value = '') => String(value)
      .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;').replaceAll("'", '&#039;');

    let activeLightboxIndex = 0;
    let lightboxTrigger = null;
    let sizeGuideTrigger = null;
    let touchStartX = 0;

    const visibleImageButtons = () => imageExpandButtons.filter((button) => {
      const media = button.closest('.chub-pdp__image');
      return !media || !media.hidden;
    });

    const showLightboxImage = (index) => {
      const visibleButtons = visibleImageButtons();
      if (!visibleButtons.length || !lightboxImage) return;
      activeLightboxIndex = (index + visibleButtons.length) % visibleButtons.length;
      const imageButton = visibleButtons[activeLightboxIndex];
      lightboxImage.src = imageButton.dataset.fullImage || '';
      lightboxImage.alt = imageButton.dataset.imageAlt || '';
      if (lightboxCount) {
        lightboxCount.textContent = `${activeLightboxIndex + 1} / ${visibleButtons.length}`;
        lightboxCount.hidden = visibleButtons.length < 2;
      }
      if (lightboxPrevious) lightboxPrevious.hidden = visibleButtons.length < 2;
      if (lightboxNext) lightboxNext.hidden = visibleButtons.length < 2;
    };

    const openLightbox = (trigger) => {
      if (!lightbox || !lightboxImage) return;
      const visibleButtons = visibleImageButtons();
      const requestedIndex = visibleButtons.indexOf(trigger);
      lightboxTrigger = trigger;
      showLightboxImage(requestedIndex >= 0 ? requestedIndex : 0);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-lightbox-open');
      lightbox.querySelector('.chub-pdp-lightbox__close')?.focus();
    };

    const closeLightbox = () => {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('product-lightbox-open');
      lightboxTrigger?.focus();
    };

    const openSizeGuide = (trigger) => {
      if (!sizeGuide) return;
      sizeGuideTrigger = trigger;
      sizeGuide.hidden = false;
      sizeGuide.setAttribute('aria-hidden', 'false');
      sizeGuideTriggers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('product-size-guide-open');
      sizeGuide.querySelector('.chub-size-guide__close')?.focus();
    };

    const closeSizeGuide = () => {
      if (!sizeGuide || sizeGuide.hidden) return;
      sizeGuide.hidden = true;
      sizeGuide.setAttribute('aria-hidden', 'true');
      sizeGuideTriggers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('product-size-guide-open');
      sizeGuideTrigger?.focus();
    };

    imageExpandButtons.forEach((button) => {
      button.addEventListener('click', () => openLightbox(button));
    });

    lightbox?.querySelectorAll('[data-lightbox-close]').forEach((button) => {
      button.addEventListener('click', closeLightbox);
    });
    lightboxPrevious?.addEventListener('click', () => showLightboxImage(activeLightboxIndex - 1));
    lightboxNext?.addEventListener('click', () => showLightboxImage(activeLightboxIndex + 1));

    sizeGuideTriggers.forEach((button) => {
      button.addEventListener('click', () => openSizeGuide(button));
    });
    sizeGuide?.querySelectorAll('[data-size-guide-close]').forEach((button) => {
      button.addEventListener('click', closeSizeGuide);
    });
    sizeGuideUnitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const useCentimeters = button.dataset.sizeUnit === 'cm';
        sizeGuideUnitButtons.forEach((unitButton) => {
          unitButton.setAttribute('aria-pressed', String(unitButton === button));
        });
        sizeGuideMeasurements.forEach((measurement) => {
          const inches = Number(measurement.dataset.sizeMeasurement);
          measurement.textContent = useCentimeters
            ? `${(inches * 2.54).toFixed(2)} cm`
            : `${Number.isInteger(inches) ? inches.toFixed(2) : measurement.dataset.sizeMeasurement} in`;
        });
      });
    });

    lightboxMedia?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    lightboxMedia?.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || 0;
      const swipeDistance = touchEndX - touchStartX;
      if (Math.abs(swipeDistance) > 45) {
        showLightboxImage(activeLightboxIndex + (swipeDistance < 0 ? 1 : -1));
      }
    }, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sizeGuide && !sizeGuide.hidden) {
        closeSizeGuide();
        return;
      }
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showLightboxImage(activeLightboxIndex - 1);
      if (event.key === 'ArrowRight') showLightboxImage(activeLightboxIndex + 1);
    });

    const recommendationCardMarkup = (recommendedProduct) => {
      const imageSource = typeof recommendedProduct.featured_image === 'string'
        ? recommendedProduct.featured_image
        : recommendedProduct.featured_image?.url
          || recommendedProduct.featured_image?.src
          || recommendedProduct.image
          || (typeof recommendedProduct.images?.[0] === 'string'
            ? recommendedProduct.images[0]
            : recommendedProduct.images?.[0]?.src || recommendedProduct.images?.[0]?.url)
          || '';
      const imageUrl = imageSource
        ? `${imageSource}${imageSource.includes('?') ? '&' : '?'}width=700`
        : '';
      const productUrl = recommendedProduct.url || `/products/${recommendedProduct.handle}`;
      const numericPrice = typeof recommendedProduct.price === 'string' && recommendedProduct.price.includes('.')
        ? Math.round(Number(recommendedProduct.price) * 100)
        : Number(recommendedProduct.price || 0);
      const formattedPrice = recommendedProduct.priceText || new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: section.dataset.currency || 'USD'
      }).format(numericPrice / 100);
      const formattedComparePrice = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: section.dataset.currency || 'USD'
      }).format(3999 / 100);
      const image = imageUrl
        ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(recommendedProduct.title)}" width="700" height="875" loading="lazy">`
        : '';

      return `<article class="riff-rec-card" data-recommended-product-id="${escapeHtml(recommendedProduct.id)}">
        <a class="riff-rec-card__image" href="${escapeHtml(productUrl)}" aria-label="View ${escapeHtml(recommendedProduct.title)}">${image}</a>
        <p class="riff-rec-card__type">${escapeHtml(recommendedProduct.type || recommendedProduct.product_type || 'Graphic T-Shirt')}</p>
        <h3><a href="${escapeHtml(productUrl)}">${escapeHtml(recommendedProduct.title)}</a></h3>
        <div class="riff-rec-card__price"><strong>${formattedPrice}</strong><s>${formattedComparePrice}</s><span class="riff-rec-card__sale-badge">25% OFF TODAY</span></div>
      </article>`;
    };

    const loadBestSellingProductsPage = (page = 1) => {
      window.RiffstitchBestSellingProductPages ||= {};
      if (!window.RiffstitchBestSellingProductPages[page]) {
        const root = window.Shopify?.routes?.root || '/';
        const pageQuery = page > 1 ? `&page=${page}` : '';
        window.RiffstitchBestSellingProductPages[page] = fetch(`${root}collections/all?sort_by=best-selling${pageQuery}`, {
          headers: { Accept: 'text/html' }, credentials: 'same-origin'
        }).then(async (response) => {
          if (!response.ok) return [];
          const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
          return [...documentCopy.querySelectorAll('.product-card[data-product-id]')].map((card) => {
            const link = card.querySelector('.product-card__content p a');
            const image = card.querySelector('.product-card__media img');
            return {
              id: card.dataset.productId,
              title: link?.textContent?.trim() || '',
              url: link?.getAttribute('href') || '',
              image: image?.getAttribute('src') || '',
              type: card.querySelector('.product-card__content h3')?.textContent?.trim() || 'Graphic T-Shirt',
              priceText: card.querySelector('.product-card__pricing strong')?.textContent?.trim() || ''
            };
          }).filter((bestSeller) => bestSeller.id && bestSeller.title && bestSeller.url);
        }).catch(() => []);
      }
      return window.RiffstitchBestSellingProductPages[page];
    };

    const getBestSellerFill = async (excludedProductIds, requestedCount) => {
      const bestSellers = [];
      const usedProductIds = new Set(excludedProductIds);
      let page = 1;

      while (bestSellers.length < requestedCount && page <= 12) {
        const candidates = await loadBestSellingProductsPage(page);
        candidates.forEach((candidate) => {
          const candidateId = String(candidate.id);
          if (bestSellers.length >= requestedCount || usedProductIds.has(candidateId)) return;
          usedProductIds.add(candidateId);
          bestSellers.push(candidate);
        });
        if (candidates.length < 24) break;
        page += 1;
      }

      return bestSellers;
    };

    const showProductRecommendations = async (productId, relatedProducts = []) => {
      const excludedProductIds = new Set([String(productId)]);
      relatedProducts.forEach((recommendedProduct) => {
        excludedProductIds.add(String(recommendedProduct.id));
      });
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' }, credentials: 'same-origin'
        });
        if (cartResponse.ok) {
          const currentCart = await cartResponse.json();
          currentCart.items.forEach((item) => excludedProductIds.add(String(item.product_id)));
        }
      } catch (error) {
        // The current product is still excluded if the cart is unavailable.
      }

      const remainingSlots = Math.max(0, 16 - relatedProducts.length);
      const bestSellers = await getBestSellerFill(excludedProductIds, remainingSlots);
      const recommendations = [...relatedProducts, ...bestSellers].slice(0, 16);
      if (recommendations.length) {
        recommendationsRail.innerHTML = recommendations.map(recommendationCardMarkup).join('');
      }
    };

    const loadRelatedRecommendations = async () => {
      const recommendationBase = section.dataset.recommendationsUrl;
      const productId = section.dataset.productId;
      if (!recommendationsRail || !recommendationBase || !productId) return;

      const endpoint = recommendationBase.endsWith('.json') ? recommendationBase : `${recommendationBase}.json`;
      try {
        const response = await fetch(`${endpoint}?product_id=${encodeURIComponent(productId)}&limit=10&intent=related`, {
          headers: { Accept: 'application/json' }, credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('Recommendation request failed');
        const { products = [] } = await response.json();
        const seenProductIds = new Set([String(productId)]);
        const relatedProducts = products.filter((recommendedProduct) => {
          const recommendedProductId = String(recommendedProduct.id);
          if (seenProductIds.has(recommendedProductId)) return false;
          seenProductIds.add(recommendedProductId);
          return true;
        }).slice(0, 16);
        await showProductRecommendations(productId, relatedProducts);
      } catch (error) {
        await showProductRecommendations(productId);
      }
    };

    const selectedOptions = () => optionGroups.map((optionGroup) =>
      optionGroup.querySelector('.is-selected')?.dataset.optionValue
    );

    const syncOptionSelections = (variant) => {
      optionGroups.forEach((optionGroup, index) => {
        const selectedValue = variant.options[index];
        optionGroup.querySelectorAll('[data-option-value]').forEach((candidate) => {
          const isSelected = candidate.dataset.optionValue === selectedValue;
          candidate.classList.toggle('is-selected', isSelected);
          candidate.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        const label = optionGroup.querySelector('[data-option-label]');
        if (label) label.textContent = selectedValue;
      });
    };

    const updateOptionAvailability = (variant) => {
      optionGroups.forEach((optionGroup, optionIndex) => {
        optionGroup.querySelectorAll('[data-option-value]').forEach((button) => {
          const value = button.dataset.optionValue;
          const hasAvailableVariant = variants.some((candidate) => {
            if (!candidate.available || candidate.options[optionIndex] !== value) return false;
            return candidate.options.slice(0, optionIndex).every((optionValue, previousIndex) =>
              optionValue === variant.options[previousIndex]
            );
          });
          button.disabled = !hasAvailableVariant;
          button.setAttribute('aria-disabled', hasAvailableVariant ? 'false' : 'true');
        });
      });
    };

    const updateGallery = (color) => {
      if (!colorGroup || !color || productMedia.length === 0) return;

      const colorKey = normalizeColor(color);
      const filenameMatches = productMedia.filter((media) => {
        const image = media.querySelector('img');
        const mediaText = normalizeColor(`${image?.currentSrc || image?.src || ''} ${image?.alt || ''}`);
        return mediaText.includes(colorKey);
      });

      let matchingMedia = filenameMatches.slice(0, 2);

      if (matchingMedia.length < 2) {
        const colorValues = [...colorGroup.querySelectorAll('[data-option-value]')]
          .map((button) => button.dataset.optionValue);
        const featuredIndexes = colorValues.map((value) => {
          const colorVariant = variants.find((variant) => variant.options[colorOptionIndex] === value);
          const featuredId = String(colorVariant?.featured_image?.id || '');
          return productMedia.findIndex((media) => media.dataset.mediaId === featuredId);
        });
        const selectedVariant = variants.find((variant) => variant.options[colorOptionIndex] === color);
        const selectedFeaturedId = String(selectedVariant?.featured_image?.id || '');
        const selectedIndex = productMedia.findIndex((media) => media.dataset.mediaId === selectedFeaturedId);
        const colorCount = colorValues.length;
        const usesFrontThenBackGroups = productMedia.length >= colorCount * 2
          && featuredIndexes.every((index) => index >= 0 && index < colorCount)
          && new Set(featuredIndexes).size === colorCount;

        if (selectedIndex >= 0 && usesFrontThenBackGroups) {
          matchingMedia = [productMedia[selectedIndex], productMedia[selectedIndex + colorCount]].filter(Boolean);
        } else if (selectedIndex >= 0) {
          const nextFeaturedIndex = featuredIndexes
            .filter((index) => index > selectedIndex)
            .sort((a, b) => a - b)[0] ?? productMedia.length;
          matchingMedia = productMedia.slice(selectedIndex, Math.min(nextFeaturedIndex, selectedIndex + 2));
        }
      }

      productMedia.forEach((media) => {
        media.hidden = matchingMedia.length > 0 && !matchingMedia.includes(media);
      });

      const gallery = section.querySelector('.chub-pdp__gallery');
      if (gallery) gallery.scrollLeft = 0;
    };

    if (colorGroup) {
      updateGallery(colorGroup.querySelector('.is-selected')?.dataset.optionValue);
    }

    loadRelatedRecommendations();

    const initialVariant = variants.find((variant) => String(variant.id) === select.value);
    if (initialVariant) updateOptionAvailability(initialVariant);

    optionGroups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;

          const chosen = selectedOptions();
          const clickedIndex = Number(group.dataset.optionPosition) - 1;
          chosen[clickedIndex] = button.dataset.optionValue;

          let variant = variants.find((candidate) =>
            candidate.options.every((value, index) => value === chosen[index])
          );

          if (!variant) {
            const compatibleVariants = variants.filter((candidate) =>
              candidate.options[clickedIndex] === button.dataset.optionValue
            );
            variant = compatibleVariants.find((candidate) => candidate.available) || compatibleVariants[0];
          }

          if (!variant) return;

          syncOptionSelections(variant);
          updateOptionAvailability(variant);
          select.value = variant.id;
          addButton.disabled = !variant.available;
          addLabel.textContent = variant.available ? 'Add To Cart' : 'Sold Out';
          const formattedPrice = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: section.dataset.currency || 'USD'
          }).format(variant.price / 100);
          if (productPrice) productPrice.textContent = formattedPrice;
          if (colorGroup) updateGallery(variant.options[colorOptionIndex]);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
